import { useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const sliceColour = (i, n) => {
  const t = n <= 1 ? 0 : i / (n - 1);
  return `hsl(${188 + t * 40}, 75%, ${64 - t * 20}%)`;
};

// Donut version of a WhereAndWhat section: rows [{label, pct, right, icon, highlight}]
export const DonutSection = ({ rows, testId }) => {
  const [active, setActive] = useState(null);
  const data = rows.filter((r) => r.pct > 0);
  if (!data.length) return null;
  const focus = active != null ? data[active] : data.reduce((a, b) => (b.pct > a.pct ? b : a), data[0]);
  return (
    <div className="flex flex-col sm:flex-row items-center gap-4">
      <div className="relative w-40 h-40 shrink-0" data-testid={`${testId}-donut`}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie data={data} dataKey="pct" nameKey="label" innerRadius="62%" outerRadius="95%" paddingAngle={1.5} stroke="none"
              startAngle={90} endAngle={-270} onMouseEnter={(_, i) => setActive(i)} onMouseLeave={() => setActive(null)}>
              {data.map((d, i) => (
                <Cell key={d.label} fill={sliceColour(i, data.length)} opacity={active == null || active === i ? 1 : 0.35} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none px-6">
          <p className="text-white text-lg font-bold tabular-nums leading-none">{focus.pct.toFixed(focus.pct >= 10 ? 0 : 1)}%</p>
          <p className="text-slate-300 text-[10px] mt-1 text-center leading-tight line-clamp-2">{focus.label}</p>
        </div>
      </div>
      <ul className="flex-1 min-w-0 w-full max-w-md space-y-1.5">
        {data.map((r, i) => {
          const Icon = r.icon;
          return (
            <li
              key={r.label}
              className={`flex items-center gap-2 text-xs transition-opacity ${active == null || active === i ? "opacity-100" : "opacity-50"}`}
              onMouseEnter={() => setActive(i)}
              onMouseLeave={() => setActive(null)}
              data-testid={`${testId}-${i}`}
            >
              <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ background: sliceColour(i, data.length) }} />
              {Icon && <Icon className="w-3.5 h-3.5 text-sky-300 shrink-0" />}
              <span className="text-slate-200 truncate">{r.label}</span>
              {r.highlight && <span className="px-1.5 py-0.5 rounded-full text-[9px] font-bold bg-lime-400/15 text-lime-300 border border-lime-400/30 shrink-0 whitespace-nowrap">Best click rate</span>}
              <span className="text-white font-semibold tabular-nums ml-auto shrink-0">{r.right}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default DonutSection;
